import { B2BStoreNamespace as storeNS } from '../store/index';
import store from '../../../store/index';
import * as types from '../store/types'
import { NotificationService } from "../../../dt-plugins/notification/notification.service";
import storeB2B from '../store/index';
import { FixedProperties } from '../models/Fixed-Properties';
import * as I18nActionTypes from "../../../store/app/i18n/types";
export const InitB2bRoute = (to, from, next) => {
  store.dispatch(`${storeNS}/${types.B2B_FETCH_USER_DETAILS}`).then(res => {
    console.log('language', storeB2B.state.userDetails);
    store.dispatch(I18nActionTypes.UPDATE_SYSTEM_LANGUAGE, {
      value: storeB2B.state.userDetails.language,
      text: "English",
    })
      .then((a) => {
        store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
          "b2b",
        ])
      });
    if (to.fullPath === "/b2b/login" && storeB2B.state.is_Logged_In) {
      next({ name: FixedProperties.HOME_TITLE });
      
    }
    else {
      next();
    }

  }).catch(res => {

  })
}
export const InitB2bLanguage = (to, from, next) => {
  store.dispatch(I18nActionTypes.UPDATE_SYSTEM_LANGUAGE, {
    value: storeB2B.state.userDetails.language,
    text: "English",
  })
    .then((a) => {
      store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
        "b2b",
      ])
    }).then(res => {
      next()
    });
}


export const RequireGuradChecked = (to, from, next) => {
  const route = storeB2B.state.appNavItems.find(x => x.title == to.name)
  if (route && route.title === to.name && route.hasPermission) {
    next();
  }
  next();
}
export const isLoggedIn = (to, from, next) => {
  const route = storeB2B.state.is_Logged_In
  if (route && route.title === to.name && storeB2B.state.is_Logged_In) {
    next();
  }

}



